import React from 'react'
import styled from 'styled-components'
import Icon from 'decorators/Icon'

export const arrowDirections = {
  left: 'left',
  up: 'up',
  right: 'right',
  down: 'down'
}

const directions = {
  [arrowDirections.left]: 'rotate3d(0, 0, 1, 180deg)',
  [arrowDirections.up]: 'rotate3d(0, 0, 1, -90deg)',
  [arrowDirections.right]: 'rotate3d(0, 0, 0, 0)',
  [arrowDirections.down]: 'rotate3d(0, 0, 1, 90deg)'
}

const Svg = styled.svg`
  transform: ${props => directions[props.direction]};
  transform-origin: 50% 50%;
  transition: transform 0.3s;
`

// eslint-disable-next-line react/prop-types
const _IconArrow = ({ t, className, direction = arrowDirections.right, width, height, fill }) => (
  <Svg
    direction={direction}
    width={width}
    height={height}
    className={className}
    viewBox='0 0 13 22'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>{t('Arrow _direction_', { direction })}</title>
    <g fill='none' fillRule='evenodd' transform='translate(-19 -14)'>
      <g transform='translate(14 14)'>
        <rect width='22' height='22' rx='2' />
        <path d='M6.78753043,22 C6.32280464,22 5.85927045,21.8200677 5.50893869,21.4613947 C4.81899963,20.7547732 4.83210728,19.6227488 5.53872881,18.9340014 L13.6249577,11.0408125 L5.63524878,3.05110359 C4.93696848,2.35282329 4.93696848,1.22079892 5.63524878,0.523710223 C6.33352908,-0.174570074 7.46436185,-0.174570074 8.16264215,0.523710223 L17.4321344,9.79201083 C17.7693585,10.1292349 17.957632,10.5880027 17.9552488,11.0670278 C17.951674,11.5448612 17.758634,12.0012458 17.4166435,12.3348951 L8.03633206,21.4911848 C7.68838351,21.8307921 7.23795697,22 6.78753043,22'
          fill={fill} />
      </g>
    </g>
  </Svg>
)

const IconArrow = Icon(_IconArrow)
IconArrow.Down = (props) => (<IconArrow {...props} direction='down' />)
IconArrow.Up = (props) => (<IconArrow {...props} direction='up' />)
IconArrow.Left = (props) => (<IconArrow {...props} direction='left' />)
IconArrow.Right = (props) => (<IconArrow {...props} direction='right' />)

export default IconArrow
